<div class="box-select">
  <label v-if="label" :for="updatedLabel" class="txt-ellipsis bold">
    {{ updatedLabel && $t(updatedLabel) }}
    <span v-if="required" class="txt-danger txt-required">
      <span>*</span>
    </span>
  </label>

  <div @click="onSelect" v-outside="outsideClick" @keydown="handleKeyDown" @keydown.stop tabindex="0" :class="{'active' : isDropdown, 'outline-danger': isError, 'select-box-disabled' : readonly}" class="row c-select">
    <div class="c-option">
      <div class="select-valued font15">
        <span v-if="!input">{{ selectedValue || placeholder && $t(placeholder) || $t('componentSelect') }}</span>
        <input v-else v-model="manualInput" @input="onManualInput" type="text" class="input-select" :placeholder="$t('componentWriteHere')" :disabled="readonly">
      </div>
      <i v-if="!readonly && clear && value" @click="deleteValue" @click.stop @dblclick.stop class="fa fa-times-circle bold ic-arrow-down" style="right: 40px;color: var(--gray-dark);"></i>
      <i
        :class="isDropdown ? 'icon-element-up':'icon-element-down', {'mr0' : readonly && selectedValue}"
        class="fa-angle-down fa bold ic-arrow-down"
      ></i>
      <!-- <i
        :class="isDropdown ? 'icon-element-up':'icon-element-down', {'mr22' : readonly && selectedValue}"
        class="fa-angle-down fa bold ic-arrow-down"
      ></i> -->
      <!-- <button
        v-if="readonly && selectedValue"
        @click.stop
        @click="copyToClipboard"
        :tooltip="showPopup ? $t('componentCopied') : $t('componentCopy')"
        class="btn btn-danger btn-xs clone-icon tooltip mr3"
        style="right: 19px;top: 0px;height: 100%;"
      >
        <i class="fa fa-clone"></i>
      </button> -->
    </div>
    <div v-if="isDropdown" :class="[isTop ? 'bottom-dropdown' : 'top-dropdown']" class="c-select-dropdown c-select-dropdown-active" @click.stop>
      <div class="c-select-dropdown-item">
        <input v-if="searchable && !isTop" @input="onFilter" v-model="keySearch" :ref='"keySearchQuery"' :placeholder="$t('componentSearch')" @click.stop type="text" class="input mb10 c-search-input">
        <div class="row c-select-option-list">
          <li @click="onSelectValue(item)" v-for="item in optionList" :key="item" @click.stop :class="{'active' : item?.[optionLabel] === selectedValue}" class="font15">
            {{ item?.[optionLabel] }}
          </li>
  
          <div v-if="!optionList.length" @click.stop class="no-select-data">{{ $t('componentEmptyData') }}</div>
        </div>
        <input v-if="searchable && isTop" @input="onFilter" v-model="keySearch" :ref='"keySearchQuery"' :placeholder="$t('componentSearch')" @click.stop type="text" class="input mt10 c-search-input">
      </div>
    </div>
  </div>

  <p v-if="isError && showError" class="mb0 txt-danger font14 mt3">
    <span>{{ $t(isError) }}</span>
  </p>
</div>
